import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { useNavigate } from 'react-router-dom';

const RoboticsImageAdd = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    kit_id: '',
    type: '',
    file: null,
  });

  const [kits, setKits] = useState([]);

  // Validation state
  const [errors, setErrors] = useState({
    kit_id: '',
    type: '',
    file: '',
  });

  useEffect(() => {
    callAPI('get', 'admin/robotic-kits');
  }, []);

  useEffect(() => {
    if (statusCode === 200 && responce?.data) {
      if (Array.isArray(responce.data)) {
        const kitOptions = responce.data.map((kit) => ({
          label: kit.name,
          value: kit.id,
        }));
        setKits(kitOptions);
      } else if (responce?.message) {
        toast.success(responce.message);
      }
    }
  }, [responce, statusCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({ ...prev, file: e.target.files[0] }));
    setErrors((prev) => ({ ...prev, file: '' }));
  };

  const handleSelectChange = (selected) => {
    setForm((prev) => ({ ...prev, kit_id: selected?.value }));
    setErrors((prev) => ({ ...prev, kit_id: '' }));
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = { kit_id: '', type: '', file: '' };

    if (!form.kit_id) {
      newErrors.kit_id = 'Kit is required';
      valid = false;
    }
    if (!form.type) {
      newErrors.type = 'Type is required';
      valid = false;
    }
    if (!form.file) {
      newErrors.file = 'File is required';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append('kit_id', form.kit_id);
    formData.append('type', form.type);
    formData.append('file', form.file);

    callAPI('post', 'admin/robotic-media', formData, true);
  };

  useEffect(() => {
    if (statusCode === 201) {
      toast.success('Robotics Image added successfully!');
      setTimeout(() => navigate('/roboticsimage/list'), 1000);
    }
  }, [statusCode]);

  return (
    <AdminAppBody
      content={
        <div className="container mt-4">
          <h4>Add Kit Media</h4>

          {/* Kit Select */}
          <div className="mb-3">
            <label className="form-label">Select Kit</label>
            <Select
              options={kits}
              value={kits.find((k) => k.value === form.kit_id)}
              onChange={handleSelectChange}
              placeholder="Select Kit"
            />
            {errors.kit_id && <span className="text-danger">{errors.kit_id}</span>}
          </div>

          {/* Type Select */}
          <div className="mb-3">
            <label className="form-label">Type</label>
            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">Select Type</option>
              <option value="image">Image</option>
              <option value="video">Video</option>
            </select>
            {errors.type && <span className="text-danger">{errors.type}</span>}
          </div>

          {/* File Upload */}
          <div className="mb-3">
            <label className="form-label">File</label>
            <input
              type="file"
              name="file"
              className="form-control"
              onChange={handleFileChange}
              accept={form.type === 'image' ? 'image/*' : 'video/*'}
            />
            {errors.file && <span className="text-danger">{errors.file}</span>}
          </div>

          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      }
    />
  );
};

export default RoboticsImageAdd;
